/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Requestsmakeonrequest3Inputs */

const en_requestsmakeonrequest3 = /** @type {(inputs: Requestsmakeonrequest3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Change visibility`)
};

const de_requestsmakeonrequest3 = /** @type {(inputs: Requestsmakeonrequest3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sichtbarkeit ändern`)
};

/**
* | output |
* | --- |
* | "Change visibility" |
*
* @param {Requestsmakeonrequest3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const requestsmakeonrequest3 = /** @type {((inputs?: Requestsmakeonrequest3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Requestsmakeonrequest3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_requestsmakeonrequest3(inputs)
	return de_requestsmakeonrequest3(inputs)
});
export { requestsmakeonrequest3 as "requestsMakeOnRequest" }